export default __webpack_public_path__ + "static/media/gd10.e8940a23.png";